import { render, staticRenderFns } from "./MoviesGroup.vue?vue&type=template&id=497e56b4&scoped=true&"
import script from "./MoviesGroup.vue?vue&type=script&lang=js&"
export * from "./MoviesGroup.vue?vue&type=script&lang=js&"
import style0 from "./MoviesGroup.vue?vue&type=style&index=0&id=497e56b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e56b4",
  null
  
)

export default component.exports